import axios from '@/services/api'

/**
 * @param {Number} id Chat ID
 *
 * @returns {Promise<Object>}
 */
export const getChat = (id) => {
	const url = `api/chats/${id}`
	return axios.get(url)
}

/**
 * @param {Number} id Chat ID
 * @param {Object} query Search query
 *
 * @returns {Promise<Object>}
 */
export const fetchMessages = ({ id, query }) => {
	const url = `api/chats/${id}/messages/`
	return axios.get(url, { params: query })
}

/**
 * @param {Object} query Search query
 * @returns {Promise<Object>}
 */
export const fetchChats = (query) => {
	const url = 'api/chats'
	return axios.get(url, { params: query })
}

/**
 * @param {Number} chatId Chat ID
 * @param {Object} data Chat data
 *
 * @returns {Promise<Object>}
 */
export const storeMessage = (chatId, data) => {
	const url = `api/chats/${chatId}/messages`
	return axios.post(url, data)
}

/**
 * @param {Number} chatId Chat ID
 * @param {Object} data Chat data
 *
 * @returns {Promise<Object>}
 */
export const editMessage = (chatId, data) => {
	const url = `api/chats/${chatId}/messages/${data.messageId}`
	return axios.post(url, data.content)
}

/**
 * @param {Number} chatId Chat ID
 * @param {Number} messageId Message ID
 *
 * @returns {Promise<Object>}
 */
export const deleteMessage = ({ chatId, messageId }) => {
	const url = `api/chats/${chatId}/messages/${messageId}`
	return axios.delete(url)
}

/**
 * @param {Object} data Chat data
 *
 * @returns {Promise<Object>}
 */
export const startChat = (data) => {
	const url = 'api/chats'
	return axios.post(url, data)
}

export const deleteChat = (chatId) => {
	const url = `api/chats/${chatId}`
	return axios.delete(url)
}

/**
 * @returns {Promise<Object>}
 */
export const getViolationsList = () => {
	const url = 'api/chats/block-reasons'
	return axios.get(url)
}

/**
 * @param {Number} chatId
 * @param {Number} userId
 * @param {String} reason
 * @returns {Promise<Object>}
 */
export const chatReport = (chatId, userId, reason) => {
	const url = `api/chats/${chatId}/user/${userId}/complain`
	return axios.post(url, { reason })
}

/**
 * @param {Number} chatId
 * @returns {Promise<Object>}
 */
export const markMessagesAsRead = (chatId) => {
	const url = `api/chats/${chatId}/read`
	return axios.post(url)
}
